import CustomCheckBox from "@/components/CustomCheckBox/CustomCheckBox.vue";
import SocialInformationTooltip from "@/components/SocialInformationTooltip/SocialInformationTooltip.vue";
export default {
    name: 'Skippable',
    components: {
        CustomCheckBox, SocialInformationTooltip
    },
    data() {
        return {
            ces: false,
            activeItem: null,
            seconds: [
                {id: 1, s: 1},
                {id: 2, s: 10},
                {id: 3, s: 20},
                {id: 4, s: 30},
                {id: 5, s: 45}
            ]
        }
    },
    props: {
        prefixInput: String,
        activeCheckSkip: Boolean,
        item: Object,
    },
    methods: {
        clickCheck(payload) {
            this.ces = payload
            if (this.ces) {
                const {id, s} = this.seconds[0]
                this.selecteSkipTime(s, id)
            } else {
                this.activeItem = 0
                this.$props.item.check.skippable = this.ces
                this.selecteSkipTime(false, 0)
            }
        },
        selecteSkipTime(sec, idx) {
            if (idx === 0) {
                this.ces = false
            } else {
                this.ces = true
            }
            this.activeItem = idx
            this.$props.item.check.skippable = sec
            this.$emit('second', this.$props.item)
        },
        getInfoMessage(itemName) {
            if (itemName === 'Twitter') {
                return `
                <p>Please note that Twitter doesn’t allow actions such as Follow, Like, Reply, or Share to be mandatory 
                for any gated content. </p>
                <p>To comply with this Twitter rule, your gate steps should be skippable. </p>
                <p>We recommend that you always combine a Twitter gate step with additional gate steps such as email 
                capture. This ensures that you establish required connections each time a visitor unlocks your content - 
                even if the Twitter step was skipped. </p>`;
            }
            if (itemName === 'TikTok') {
                return `
                <p>Please note that TikTok doesn’t allow actions such as Follow, Like, Comment, or Share to be mandatory 
                for any gated content. </p>
                <p>To comply with this TikTok rule, your gate steps should be skippable. </p>
                <p>We recommend that you always combine a TikTok gate step with additional gate steps such as email 
                capture. This ensures that you establish required connections each time a visitor unlocks your content 
                - even if the TikTok step was skipped. </p>`;
            }
        }
    },
    created(){
        if(!this.$props.item.check.skippable){
            this.activeItem = 0
            this.$props.item.check.skippable = this.ces
            this.selecteSkipTime(false, 0)
        }else{
            let sid = this.seconds.find(item => item.s === this.$props.item.check.skippable).id
            const {id, s} = this.seconds[sid-1]
            this.selecteSkipTime(s, id)
        }

    }
}
